// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2b8uCvYY6KLAe9 {\n  min-height: 600px;\n}\n._26hCpnUwZwk-n0 {\n  align-items: center;\n  background-color: #E4F0F6;\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 8px 8px 16px;\n}\n._3Bc05Kd73Kqbg3 {\n  color: #172B4D;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  line-height: 20px;\n  margin-top: 24px;\n  margin: 0;\n}\n._1vuXz_9XZpq8Fw {\n  display: flex;\n}\n._1Kb_zi1CgfYoMW {\n  margin: 0 8px 0 0;\n}\n._3OuhQ1jhsGI5P1 {\n  margin: 0;\n}\n._2v8vv1EEEF7GlF {\n  float: left;\n  width: 568px;\n}\n._20jioSNPRpZWZR {\n  float: right;\n  padding: 0 16px 8px 8px;\n  width: 168px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mirrorCardBack": "_2b8uCvYY6KLAe9",
	"banner": "_26hCpnUwZwk-n0",
	"bannerText": "_3Bc05Kd73Kqbg3",
	"bannerButtons": "_1vuXz_9XZpq8Fw",
	"viewOriginalCardButton": "_1Kb_zi1CgfYoMW",
	"closeButton": "_3OuhQ1jhsGI5P1",
	"mainColumn": "_2v8vv1EEEF7GlF",
	"sidebarColumn": "_20jioSNPRpZWZR"
};
export default ___CSS_LOADER_EXPORT___;
